import React from 'react';
import { Link } from 'react-router-dom';

export default function Projects() {
  const projects = [
    {
      title: 'Classic Tic-Tac-Toe Game',
      description:
        'A clean, responsive, and interactive Tic-Tac-Toe game built with React. Features turn tracking, dynamic state management, and win/draw detection.',
      liveLink: '/projects/tic-tac-toe',
      isInternal: true,
      codeLink: 'https://github.com/sunnysjamil/tic-tac-toe-game',
      icon: (
        <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 3v18M19 3v18M3 5h18M3 19h18M9 9l6 6m0-6l-6 6" />
        </svg>
      ),
    },
    {
      title: 'Personal Portfolio Website',
      description:
        'A modern personal website designed to act as a professional hub. It features a detailed resume, project gallery, and integrated tools for scheduling meetings via Google Calendar.',
      liveLink: '/',
      isInternal: true,
      codeLink: 'https://github.com/sunnysjamil/sunny-jamil-dashboard',
      icon: (
        <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.75 3.104l-2.286 9.144a.75.75 0 001.372.342l2.286-9.144a.75.75 0 00-1.372-.342zM14.25 3.104a.75.75 0 00-1.372.342l2.286 9.144a.75.75 0 001.372-.342l-2.286-9.144zM5.25 12a.75.75 0 000 1.5h13.5a.75.75 0 000-1.5H5.25z" />
        </svg>
      ),
    },
    {
      title: 'Connect 4',
      description:
        'A classic two-player connection game built with React state and styled with Tailwind CSS. Features win/draw detection and highlights the winning pieces with animated pulses.',
      liveLink: '/projects/connect-4',
      isInternal: true,
      codeLink: 'https://github.com/sunnysjamil/sunny-jamil-dashboard/blob/main/projects/connect-4.html',
      icon: (
        <svg className="w-24 h-24 text-blue-600" viewBox="0 0 7 6" fill="none">
          <circle cx="0.5" cy="0.5" r="0.4" fill="#f59e0b" /> <circle cx="1.5" cy="0.5" r="0.4" fill="#e5e7eb" /> <circle cx="2.5" cy="0.5" r="0.4" fill="#e5e7eb" /> <circle cx="3.5" cy="0.5" r="0.4" fill="#e5e7eb" /> <circle cx="4.5" cy="0.5" r="0.4" fill="#e5e7eb" /> <circle cx="5.5" cy="0.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="0.5" r="0.4" fill="#e5e7eb" />
          <circle cx="0.5" cy="1.5" r="0.4" fill="#ef4444" /> <circle cx="1.5" cy="1.5" r="0.4" fill="#f59e0b" /> <circle cx="2.5" cy="1.5" r="0.4" fill="#e5e7eb" /> <circle cx="3.5" cy="1.5" r="0.4" fill="#e5e7eb" /> <circle cx="4.5" cy="1.5" r="0.4" fill="#e5e7eb" /> <circle cx="5.5" cy="1.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="1.5" r="0.4" fill="#e5e7eb" />
          <circle cx="0.5" cy="2.5" r="0.4" fill="#ef4444" /> <circle cx="1.5" cy="2.5" r="0.4" fill="#f59e0b" /> <circle cx="2.5" cy="2.5" r="0.4" fill="#ef4444" /> <circle cx="3.5" cy="2.5" r="0.4" fill="#e5e7eb" /> <circle cx="4.5" cy="2.5" r="0.4" fill="#e5e7eb" /> <circle cx="5.5" cy="2.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="2.5" r="0.4" fill="#e5e7eb" />
          <circle cx="0.5" cy="3.5" r="0.4" fill="#f59e0b" /> <circle cx="1.5" cy="3.5" r="0.4" fill="#ef4444" /> <circle cx="2.5" cy="3.5" r="0.4" fill="#f59e0b" /> <circle cx="3.5" cy="3.5" r="0.4" fill="#ef4444" /> <circle cx="4.5" cy="3.5" r="0.4" fill="#e5e7eb" /> <circle cx="5.5" cy="3.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="3.5" r="0.4" fill="#e5e7eb" />
          <circle cx="0.5" cy="4.5" r="0.4" fill="#ef4444" /> <circle cx="1.5" cy="4.5" r="0.4" fill="#f59e0b" /> <circle cx="2.5" cy="4.5" r="0.4" fill="#ef4444" /> <circle cx="3.5" cy="4.5" r="0.4" fill="#f59e0b" /> <circle cx="4.5" cy="4.5" r="0.4" fill="#e5e7eb" /> <circle cx="5.5" cy="4.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="4.5" r="0.4" fill="#e5e7eb" />
          <circle cx="0.5" cy="5.5" r="0.4" fill="#f59e0b" /> <circle cx="1.5" cy="5.5" r="0.4" fill="#ef4444" /> <circle cx="2.5" cy="5.5" r="0.4" fill="#f59e0b" /> <circle cx="3.5" cy="5.5" r="0.4" fill="#ef4444" /> <circle cx="4.5" cy="5.5" r="0.4" fill="#ef4444" /> <circle cx="5.5" cy="5.5" r="0.4" fill="#e5e7eb" /> <circle cx="6.5" cy="5.5" r="0.4" fill="#e5e7eb" />
        </svg>
      ),
    },
    {
      title: 'More Projects Coming Soon',
      description: 'Upcoming project for my next web application, tool, or website.',
      isComingSoon: true,
      icon: (
        <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      ),
    },
  ];

  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">My Projects</h1>
          <p className="mt-4 text-lg text-gray-600">A collection of my work and personal projects.</p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg shadow-md overflow-hidden transform hover:-translate-y-1 transition-transform duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="bg-gray-200 h-48 flex items-center justify-center">
                  {project.icon}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                  <p className="text-gray-700 mb-4">{project.description}</p>
                </div>
              </div>

              <div className="px-6 pb-6 pt-0 flex justify-between items-center border-t border-gray-100 pt-4">
                {project.isComingSoon ? (
                  <>
                    <span className="text-gray-400 font-semibold">Coming Soon</span>
                    <span className="text-gray-400">View Code</span>
                  </>
                ) : (
                  <>
                    {project.isInternal ? (
                      <Link to={project.liveLink} className="text-indigo-600 font-semibold hover:underline">
                        Play / View Live
                      </Link>
                    ) : (
                      <a
                        href={project.liveLink}
                        target="_blank"
                        rel="noreferrer"
                        className="text-indigo-600 font-semibold hover:underline"
                      >
                        View Live
                      </a>
                    )}
                    {project.codeLink && (
                      <a
                        href={project.codeLink}
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-600 hover:text-indigo-600 transition-colors"
                      >
                        View Code
                      </a>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
